module.exports = __webpack_public_path__ + "img/r2.b6a3f355.png";